module.exports = __webpack_public_path__ + "media/images/element/23-0c60069c4615d169380a6834b0388cd7.svg";